<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <el-button type="primary" size="medium" icon="iconfont" @click="addButton()">添加公告</el-button>
          </el-col>
        </el-row>
        <ApeTable ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" :current_Page="currentPage" @switchPaging="switchPaging" highlight-current-row >
          <el-table-column
            slot="second-column"
            align="center"
            label="主题">
            <template slot-scope="scope">
              <el-button type="text"
                @click="showTheme(scope.row.content)" :class=" scope.row.is_top ? 'add-color' : ''">
                {{ scope.row.is_top ? '[置顶] ' : '' }}客户系统升级公告  （{{ scope.row.created_at | DateTime}}）
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            align="center"
            label="是否置顶">
            <template slot-scope="scope">
              <div>
                {{scope.row.is_top | TranFrom}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            align="center"
            label="是否弹窗">
            <template slot-scope="scope">
              <div>
                {{scope.row.is_open | TranFrom}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            align="center"
            label="发布时间">
            <template slot-scope="scope">
              <div>
                {{scope.row.created_at}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            align="center"
            label="操作">
            <template slot-scope="scope">
              <span>
                  <el-button
                  size="mini"
                  type="default"
                  v-if="userPermissions.indexOf('company_edit') != -1"
                  @click="editButton(scope.row.id)"
                >编辑</el-button>
                <el-popover
                  v-if="userPermissions.indexOf('company_delete') != -1"
                  placement="top"
                  v-model="scope.row.visible"
                >
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference" type="danger" size="mini">删除</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
      <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
        <template slot="content">
          <el-form :model="formData" :rules="rules" ref="announceForm" label-position="right" label-width="120px">
            <el-form-item label="公告内容" prop="content">
              <!-- <el-input type="textarea" :rows="8"  v-model="formData.content"></el-input> -->
              <ApeEditor :init-html="formData.content" :editorHeight="360" @handleTinymceInput="handleTinymceInput" ></ApeEditor>
            </el-form-item>
            <el-form-item label="公告区域" prop="pages">
              <el-select v-model="formData.pages" multiple filterable clearable placeholder="请选择公告区域">
                <el-option label="首页" value="index"></el-option>
                <el-option label="任务结算" value="task"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否置顶" prop="is_top">
              <el-switch v-model="formData.is_top"></el-switch>
            </el-form-item>
            <el-form-item label="是否弹窗" prop="is_open">
              <el-switch v-model="formData.is_open"></el-switch>
            </el-form-item>
          </el-form>
        </template>
      </ModalDialog>
        <!-- 预览主题公告 -->
     <NoticeDialog :dialogVisible="announceVisible" :allowField="allowField" :htmlData="htmlData" @know="know" @handleClose="handleClose"/>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ModalDialog from '@/components/ModalDialog'
import ApeEditor from '@/components/ApeEditor'
import NoticeDialog from '@/components/NoticeDialog'
import { mapGetters } from 'vuex'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog,
    ApeEditor,
    NoticeDialog
  },
  data() {
    return {
      dataList: [],
      columns: [],
      loadingStaus: false,
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
      },
      currentPage: 1,
      dialogData:{
        visible: false,
        title: '',
        width: '50%',
        loading: true,
        modal: false
      },
      value: 'display_name',
      // 表单结构
      formData: {
        content: '',
        is_top: false,
        is_open: true,
        pages: []
      },
      pages: [],
      // 表单验证
      rules: {
        content: [{required: true, message: '输入公告内容', trigger: 'blur' }],
        pages: [{required: true, message: '选择公告', trigger: 'blur' }]
      },
      announceVisible: false,
      htmlData: '',
      allowField: ['notice'],
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    /* 查看主题信息 */
    showTheme(content) {
      this.announceVisible = true
      this.htmlData = content
    },
    know() {
      this.announceVisible = false
    },
    handleClose() {
      this.announceVisible = false
    },
    //删除
    async deleteButton(id) {
      let args = {id}
      let info = await this.$api.deleteAnnounce(args)
      if (info == 'ok') {
        this.$message.success('删除成功!')
        this.init()
      } else {
        this.$message.error(info)
      }
    },
    // 处理编辑器内容输入
    handleTinymceInput(val) {
      this.formData.content = val
    },
    //编辑
    async editButton(id) {
      this.dialogData.visible = true
      this.dialogData.title = '编辑公告'
      this.dialogData.loading = false
      let args = { id }
      this.formData.id = id
      let data = await this.$api.goBackAnnounce(args)
      this.$nextTick(() => {
        if(data) {
          this.formData.content = data.content
          this.formData.pages = data.pages.split(',')
          this.formData.is_top = data.is_top ? true : false
          this.formData.is_open = data.is_open ? true : false
        }
      })
    },


    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['announceForm'].validate((valid) => {
        if (valid) {
          if(this.formData.id) {
            this.editFormSubmit()
          }else {
            this.formSubmit()
          }
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },

    //编辑保存
    async editFormSubmit() {
      if(this.formData.is_open) {
        this.formData.is_open = 1
      }else  {
        this.formData.is_open = 0
      }
       if(this.formData.is_top) {
        this.formData.is_top = 1
      }else  {
        this.formData.is_top = 0
      }
      this.formData.pages = this.formData.pages.join(",")
      let data = await this.$api.editAnnounce(this.formData)
      this.$nextTick(() => {
        if(data) {
          this.$refs['announceForm'].clearValidate()
          this.$refs['announceForm'].resetFields()
          this.formData.id = 0
          this.dialogData.visible = false
        }
      })
      this.init()
      this.$message.success('保存成功!')
    },
    //添加,保存
    async formSubmit() {
      if(this.formData.is_open) {
        this.formData.is_open = 1
      }else  {
        this.formData.is_open = 0
      }
       if(this.formData.is_top) {
        this.formData.is_top = 1
      }else  {
        this.formData.is_top = 0
      }
      this.formData.pages = this.formData.pages.join(",")
      let data = await this.$api.createAnnounce(this.formData)
      this.$nextTick(() => {
        if(data) {
          this.$refs['announceForm'].clearValidate()
          this.$refs['announceForm'].resetFields()
          this.dialogData.visible = false
        }
      })
      this.init()
      this.$message.success('保存成功!')
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.formData.id = 0
      this.$refs['announceForm'].clearValidate()
      this.$refs['announceForm'].resetFields()
      this.dialogData.visible = false
    },
    //添加公告
    async addButton() {
      this.dialogData.visible = true
      this.dialogData.title = '添加公告'
      this.dialogData.loading = false
    },
    //分页
    switchPaging() {
      console.log('分页')
      this.init()
    },
    // 初始化列表
    async init() {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo()
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let {list,pages}= await this.$api.announceList(searchCondition)
      this.dataList = []
      this.$nextTick(() => {
        this.dataList=list
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      return condition
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .drag-handle
    font-size 24px
    cursor pointer
  .add-color
    color: #f56c6c
</style>
